import { useRef, useState } from 'react';
import { TurnstileField } from './TurnstileField';

export default function ContactForm() {
  const pending = useRef(false);
  const submission = useRef(null);
  const [token, setToken] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [retry, setRetry] = useState(0);
  const [complete,setComplete]=useState(false);
  const es = location.pathname.startsWith('/es');
  async function submit(event) {
    event.preventDefault();
    if (pending.current || complete) return;
    if (!token) { setMessage(es ? 'Espera a que termine la verificación.' : 'Please wait for verification to finish.'); return; }
    const form = event.currentTarget;
    submission.current ??= crypto.randomUUID();
    const data = new FormData(form);
    data.set('submission_id', submission.current);
    data.set('cf-turnstile-response', token);
    data.set('language', es ? 'es' : 'en');
    pending.current = true; setBusy(true); setMessage('');
    let accepted = false;
    try {
      const response = await fetch('/api/contact.php', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('submit');
      form.reset(); submission.current = null; accepted = true; setComplete(true);
      setMessage(es ? 'Gracias. Recibimos tu mensaje y nos pondremos en contacto contigo.' : 'Thank you. We received your message and will get back to you.');
    } catch {
      setMessage(es ? 'No pudimos enviar tu mensaje. Inténtalo de nuevo o llama al (956) 312-6097.' : 'We could not send your message. Please retry or call (956) 312-6097.');
    } finally { pending.current = false; setBusy(false); if(!accepted)setRetry(value=>value+1); }
  }
  return <form className="contact-form" onSubmit={submit}>
    <h2>{es ? 'Envíanos un mensaje' : 'Send Us A Message'}</h2>
    <label>{es ? 'Nombre' : 'Name'}<input name="name" required maxLength={255} autoComplete="name" /></label>
    <label>{es ? 'Correo electrónico' : 'Email'}<input type="email" name="email" required maxLength={255} autoComplete="email" /></label>
    <label>{es ? 'Teléfono' : 'Phone'}<input type="tel" name="phone" maxLength={40} autoComplete="tel" /></label>
    <label>{es ? 'Mensaje' : 'Message'}<textarea name="message" rows="6" required maxLength={5000} /></label>
    <div hidden aria-hidden="true"><label>Website<input name="website" tabIndex={-1} autoComplete="off" /></label></div>
    <TurnstileField siteKey="0x4AAAAAAEz8rUALLZjR4j-c" onToken={setToken} resetKey={retry} complete={complete} onRestart={()=>{setComplete(false);setMessage('')}}/>
    <p role="status" aria-live="polite">{message}</p>
    <button className="button" type="submit" disabled={busy || !token}>{busy ? (es ? 'Enviando…' : 'Sending…') : (es ? 'Enviar mensaje' : 'Send message')}</button>
  </form>;
}
